module.exports = __webpack_public_path__ + "img/6-1.def2096e.png";